const handleCancelActionFormActions = {
  confirm: '¿Realmente quiere cancelar esta acción?',
  title: 'CANCELAR ACCIÓN',
  newStatus: 'Cancelado'
};

export default handleCancelActionFormActions;
